import AutoAssignTable from './AutoAssignTable'

const AutoAssignPage = () => {
  return <AutoAssignTable />
}

export default AutoAssignPage
